import React, { useEffect, useState } from "react";
import { Button, Layout, Space, Table, Tag, Typography, Alert, Row, Input, Col, Modal, Form, Card, Divider } from 'antd';
import { EyeOutlined, PrinterOutlined, CaretLeftOutlined, CaretRightOutlined, LockOutlined, DeleteOutlined, CloseOutlined, WalletOutlined, EditOutlined } from '@ant-design/icons';
import { Link, useNavigate, useParams } from "react-router-dom";
import { inject, observer } from 'mobx-react'
import { cloneDeep } from "lodash";
import "./style.scss";
import Swal from "sweetalert2";
import jsPDF from 'jspdf';
import QRCode from 'qrcode';

const { Content } = Layout;
const { Title, Text } = Typography;
const { Search } = Input;

const OrganizationInvites = ({ organizationStore, userStore }) => {

  const navigate = useNavigate()
  const [form] = Form.useForm();
  let { pReferrerID, pUserType } = useParams();

  const [isEditTeamLeader, setIsEditTeamLeader] = useState(false);
  const [editableTeamLeader, setEditableTeamLeader] = useState();
  const [userType, setUserType] = useState();
  const [referrerID, setReferrerID] = useState();

  useEffect(() => {
    if(pReferrerID && pUserType) {
      setUserType(pUserType)
      setReferrerID(pReferrerID)
    }
  }, [pReferrerID, pUserType]);

  useEffect(() => {
    if(userType && referrerID) {
      organizationStore.page = 1;
      organizationStore.hasMore = false;
      organizationStore.perPage = 10;
      organizationStore.fetchMembers(referrerID, userType);
    }
  }, [userType, referrerID]);

  const handlePrevPage = () => {
    organizationStore.page = organizationStore.page - 1;
    organizationStore.fetchMembers(referrerID, userType);
  };

  const handleNextPage = () => {
    organizationStore.page = organizationStore.page + 1;
    organizationStore.fetchMembers(referrerID, userType);
  };

  const onConfirmStatus = (id, userType) => {
    Swal.fire({
      title: "Deactivate Team Leader",
      icon: "question",
      text: "Are you sure do you want to deactivate team leader?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: `Cancel`,
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        // function
      } 
    })
  };

  const onConfirmDelete = (id) => {
    Swal.fire({
      title: "Delete Team Leader",
      icon: "question",
      text: "Are you sure do you want to delete team leader?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: `Cancel`,
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        organizationStore.deleteTeamLeader(id).then(() => {
          organizationStore.fetchMembers(referrerID, userType); // Refresh the list
        });
      } 
    })
  };

  const onConfirmReset = (id) => {
    Swal.fire({
      title: "Reset Password",
      icon: "question",
      text: "Are you sure do you want to Reset Password?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: `Cancel`,
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        organizationStore.resetPassword(id).then(() => {
          organizationStore.fetchMembers(userType); // Refresh the list
        });
      } 
    })
  };

  const formatNumber = (formatnumber) => {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(formatnumber);
  };

  const columns = [
    {
      title: 'Name',
      key: 'FullName+ID',
      dataIndex: 'FullName',
      render: (FullName) => (
        <Text default>{FullName}</Text>
      )
    },
    {
      title: 'Precinct',
      key: 'Precint+ID',
      dataIndex: 'Precint',
      render: (Precint) => (
        <Text default>{Precint ?? "-"}</Text>
      )
    },
    {
      title: 'Street',
      key: 'Street+ID',
      dataIndex: 'Street',
      render: (Street) => (
        <Text default>{Street ?? "-"}</Text>
      )
    },
    {
      title: 'Address',
      key: 'Address+ID',
      dataIndex: 'Address',
      render: (Address) => (
        <Text default>{Address}</Text>
      )
    },
    {
      title: 'Gender',
      key: 'Sex+ID',
      dataIndex: 'Sex',
      render: (Sex) => (
        <Text default>{Sex ?? "-"}</Text>
      )
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      fixed: "right",
      render: (text, record) => (
        <Space size={'small'}>
          {record.UserType !== "RECRUIT" ? (
            <Link to={`/organization-invites/${record.UserID}/${record.UserType === 'TEAM_LEADER' ? 'CORE_LEADER' : (record.UserType === 'CORE_LEADER' ? 'ZONE_LEADER' : (record.UserType === 'ZONE_LEADER' ? 'RECRUIT' : '')) }`}><Button icon={<EyeOutlined/>} type="primary" ghost>View</Button></Link>
          ) : <></>}
        </Space>
      )
    },
  ];

  const handleUpdateTeamLeader = (values) => {

    organizationStore.updateTeamLeader(values, editableTeamLeader.UserID).then(() => {
      setIsEditTeamLeader(false);
      organizationStore.fetchMembers(userType); // Refresh the list
    });
  };

  return (
    <div className="admin-list-team-leader">
      <Content>
        <div className="admin-content-team-leader">
          <Row justify={"space-between"} align={"middle"}>
            <Col>
              <Title level={4}>{userType === 'CORE_LEADER' ? `Core Leaders` : (userType === 'ZONE_LEADER' ? `Zone Leaders` : `Recruits`) } List</Title>
            </Col>
            {/* <Col>
              <Row gutter={10} align={"middle"}>
                <Col>
                  <Button 
                    type="primary" 
                    icon={<UsergroupAddOutlined /> }
                    onClick={() => navigate('add')}
                  >Add Team Leader</Button>
                </Col>
                <Col>
                  <Button 
                    type="primary" 
                    icon={<WalletOutlined /> }
                    onClick={() => navigate('top-up')}
                  >Top Up Invites</Button>
                </Col>
              </Row>
            </Col> */}
          </Row>
          <Alert
            message={`List of ${userType === 'CORE_LEADER' ? `Core Leaders` : (userType === 'ZONE_LEADER' ? `Zone Leaders` : `Recruits`)}`}
            description={`List of your registered ${userType === 'CORE_LEADER' ? `core leaders` : (userType === 'ZONE_LEADER' ? `zone leaders` : `recruits`) }. If you think there's a problem with the list of users, please contact an administrator for assistance.`}
            type="info"
            showIcon
          />
          <div className="mobile-data">
            {(cloneDeep(organizationStore.members) ?? []).map((member) => (
              <Card 
                className="card-data"
                actions={[
                  <Link to={'/team-leaders/'+member.UserID}><Button icon={<EyeOutlined />} type="primary" ghost style={{width: "95%"}}>View</Button></Link>,
                  <Link to={`/team-leaders/${member.UserID}/edit`}><Button icon={<EditOutlined />} type="primary" ghost style={{width: "95%"}}>Edit</Button></Link>
                ]}
              >
                <Row gutter={10} align={"middle"}>
                  <Col>
                    <Text className="name-text" strong>{member.FullName}</Text>
                  </Col>
                  <Col>
                    <Tag color={member.IsActive == 1 ? "green" : "red"}>{member.IsActive == 1 ? 'ACTIVE' : 'INACTIVE'}</Tag>
                  </Col>
                </Row>
                <Text type="secondary">{member.ContactNumber}</Text>
                <Row gutter={10}>
                  <Text keyboard>Available Amount: {member.Amount}</Text>
                </Row>
                <Divider/>
                <Row gutter={10} justify="center">
                  {/* <Col>
                    <Link to={`/team-leaders/${member.UserID}/edit`}><Button  icon={<EditOutlined />} type="primary" ghost /></Link>
                  </Col> */}
                  <Col>
                    <Button 
                      onClick={() => onConfirmDelete(member.UserID, member.userType)}
                      loading={organizationStore.loading}
                      danger
                      icon={<DeleteOutlined />}
                    />
                  </Col>
                  <Col>
                    <Button 
                      onClick={() => onConfirmStatus(member.userID, member.userType)}
                      loading={organizationStore.loading}
                      danger
                      icon={<CloseOutlined />}
                      fullWidth
                    />
                  </Col>
                  <Col>
                    <Button 
                      fullWidth
                      onClick={() => onConfirmReset(member.userID, member.userType)}
                      loading={organizationStore.loading}
                      danger
                      icon={<LockOutlined />}
                    />
                  </Col>
                </Row>
              </Card>
              ))
            }
          </div>
          <div className="web-data">
            <Table pagination={false} columns={columns} dataSource={cloneDeep(organizationStore.members)} bordered/>
          </div>
          <ul className="pagination">
            <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPage} disabled={organizationStore.page == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
            <li className="pagination-item"><a>{organizationStore.page}</a></li>
            <li className="pagination-next "><Button type="dashed" onClick={handleNextPage} disabled={organizationStore.hasMore ? false : true}>Next<CaretRightOutlined /></Button></li>
          </ul>
          <Divider/>
          <Row gutter={10} justify={"end"}>
            <Col>
              <Button
                type="primary"
                onClick={async () => {
                  const pdf = new jsPDF({
                    unit: 'mm',
                    format: 'a4'
                  });

                  // ID Card Dimensions
                  const idWidth = 54.59;  // Fixed ID width
                  const idHeight = 86.34; // Fixed ID height
                  const marginX = 10;     // Left margin
                  const marginY = 10;     // Top margin
                  const spacingX = 5;     // Horizontal spacing between IDs
                  const spacingY = 5;     // Vertical spacing between IDs
                  const qrSize = 50;      // QR code size

                  let row = 0;
                  let col = 0;
                  let count = 0; // To track the total number of IDs on a page

                  pdf.setFontSize(8); // Keeping font size 8

                  for (const data of organizationStore.members) {
                    const qrData = {
                      VIN: data.VIN || "N/A",
                      ID: data.ID || "N/A",
                      FullName: data.FullName || "N/A",
                      Address: data.Address || "N/A",
                      Precinct: data.Precint || "N/A",
                      Sex: data.Sex || "N/A"
                    };

                    const base64QRData = btoa(JSON.stringify(qrData));
                    const qrCodeUrl = await QRCode.toDataURL(base64QRData);

                    // Calculate Position (Strict Grid with Spacing)
                    let x = marginX + col * (idWidth + spacingX);
                    let y = marginY + row * (idHeight + spacingY);

                    // Draw Border for Each ID
                    pdf.rect(x, y, idWidth, idHeight); // Rectangle border for the ID

                    // Draw QR Code (Centered)
                    pdf.addImage(qrCodeUrl, 'PNG', x + (idWidth - qrSize) / 2, y + 5, qrSize, qrSize);

                    // Adjust text position to avoid overlap
                    let textX = x + 5;
                    let textY = y + qrSize + 8; // Extra spacing to prevent overlap

                    const wrapText = (label, value) => {
                      const maxWidth = idWidth - 10; // Ensures text stays within ID width
                      const textLines = pdf.splitTextToSize(`${label}: ${value}`, maxWidth);
                      pdf.text(textX, textY, textLines);
                      textY += textLines.length * 3.5; // Adjusted line spacing
                    };

                    wrapText('VIN', qrData.VIN);
                    wrapText('Name', qrData.FullName);
                    wrapText('Address', qrData.Address);
                    wrapText('Precinct', qrData.Precinct);
                    wrapText('Gender', qrData.Sex);

                    // Move to Next Position
                    col++;
                    count++;

                    if (col >= 3) { // 3 IDs per row
                      col = 0;
                      row++;
                    }

                    // If 9 IDs reached, add a new page
                    if (count >= 9) {
                      pdf.addPage();
                      row = 0;
                      col = 0;
                      count = 0;
                    }
                  }

                  const pdfBlob = pdf.output('blob');
                  const pdfUrl = URL.createObjectURL(pdfBlob);
                  pdf.autoPrint();
                  window.open(pdfUrl, "_blank");
                }}
                icon={<PrinterOutlined/>}
              >
                Print ID
              </Button>
            </Col>
            <Col>
              <Button onClick={() => navigate(-1)}>Back</Button>
            </Col>
          </Row>

        </div>
        {/* EDIT BASIC DATA FROM TEAM LEADERS MODAL */}
        <Modal 
          title="Top up Team Leader Wallet" 
          open={isEditTeamLeader} 
          onCancel={() => setIsEditTeamLeader(false)}
          footer={[
            <Button key="cancel" onClick={() => setIsEditTeamLeader(false)}>Cancel</Button>,
            <Button key="submit" type="primary" onClick={() => form.submit()}>Save Changes</Button>
          ]}
        >
          <Form
            name="editTeamLeaderData"
            layout="vertical"
            form={form} 
            onFinish={(values) => handleUpdateTeamLeader(values)}
          >
            <Form.Item label="Name" name="FullName" rules={[{ required: true, message: "Name is required" }]}>
              <Input placeholder="Enter Name" />
            </Form.Item>
            <Form.Item label="Address" name="Address" rules={[{ required: true, message: "Address is required" }]}>
              <Input placeholder="Enter Address" />
            </Form.Item>
            <Form.Item label="Contact Number" name="ContactNumber" rules={[{ required: true, message: "Contact number is required" }]}>
              <Input placeholder="Enter Contact Number" />
            </Form.Item>
            <Form.Item label="Remarks" name="Remarks" rules={[{ required: true, message: "Remarks is required" }]}>
              <Input.TextArea placeholder="Enter Remarks" />
            </Form.Item>
          </Form>
        </Modal>
      </Content>
    </div>

  );
};

export default inject('organizationStore', 'userStore')(observer(OrganizationInvites));
